export const PKCE_VERIFIER_KEY = 'PKCE_verifier';

function makeKey(subKey?: string) {
    if (!subKey) {
        return PKCE_VERIFIER_KEY;
    }
    return `${PKCE_VERIFIER_KEY}.${subKey}`;
}

export function setPkceVerifier(PkceVerifier: string, subKey?: string): void {
    localStorage.setItem(makeKey(subKey), PkceVerifier);
}

export function getPkceVerifier(subKey?: string): string {
    return localStorage.getItem(makeKey(subKey)) ?? '';
}

export function clearPkceVerifier(subKey?: string): void {
    localStorage.removeItem(makeKey(subKey));
}
